import { render, staticRenderFns } from "./OrderSummaryLine.vue?vue&type=template&id=45fa2512"
import script from "./OrderSummaryLine.vue?vue&type=script&lang=ts"
export * from "./OrderSummaryLine.vue?vue&type=script&lang=ts"
import style0 from "./OrderSummaryLine.vue?vue&type=style&index=0&id=45fa2512&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports